import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {EventService} from "../../../services/event.service";
import {ToastrService} from "ngx-toastr";
import {AuthenticationService} from "../../../../authentication/authentication.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FacebookFundraiserDialogComponent} from "../facebook-fundraiser-dialog/facebook-fundraiser-dialog.component";
import {EditGoalDialogComponent} from "../../../components/edit-goal-dialog/edit-goal-dialog.component";
import {FacebookService} from '../../../services/facebook.service';
import {ProgressService} from '../../../services/progress.service';
import {FacebookFundraiserService} from '../../../services/facebook-fundraiser.service';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import {FacebookLoginResponse} from "@capacitor-community/facebook-login";

@Component({
    selector: 'facebook-fundraiser-summary-dialog',
    templateUrl: './facebook-fundraiser-summary-dialog.component.html',
    styleUrls: ['./facebook-fundraiser-summary-dialog.component.scss']
})
export class FacebookFundraiserSummaryDialogComponent extends BaseDialogComponent implements OnInit {

    public currentFacebookLogin: string;
    public currentLLSUserLogin: string;
    public confirmAtLeast18YearsAgeFlag: string;
    public authorizeLinkingToParentOrLegalGuardiansFBAccountFlag: string;
    public hasPermission: boolean;
    public checkingPermission: boolean;

    state: any = {
        isSubmitted: false
    };
    @Output() onInit = new EventEmitter();
    @ViewChild('f', { static: true }) form;

    constructor(
        public activeModal: NgbActiveModal,
        public eventService: EventService,
        private ToastrService: ToastrService,
        private authService: AuthenticationService,
        private facebookService: FacebookService,
        private progressService: ProgressService,
        private facebookFundraiserService: FacebookFundraiserService,
        public modalService: NgbModal,
        injector: Injector,
    ) {
        super(injector);
    }

    async ngOnInit() {
        await this.checkPermission();
        this.onInit.emit(this.form);
        if(!this.currentFacebookLogin) {
            await this.getCurrentFacebookLogin();
        }
        this.getCurrentLLSLogin();
    }

    changeFacebookUser() {
        //TODO: why don't we just call logout?
        this.hybridToolsService.openExternalLink('https://facebook.com');
        this.closeModal();
    }

    changeLLSUser() {
        this.authService.logout();
    }

    closeModal() {
        this.activeModal.close();
    }

    proceed() {
        this.state.isSubmitted = true;
        if (!this.form.valid) return;

        this.closeModal();
        if(this.eventService.selectedEvent.donations.individual.goal < 1) {
            this.openChangeGoalModal();
        } else {
            this.requestPermissionBeforeCreatingFundraiser();
        }
    }

    private openChangeGoalModal() {
        const editGoalModal = this.modalService.open(EditGoalDialogComponent);
        editGoalModal.componentInstance.totalRaised = this.eventService.getIndividualTotalRaised();
        editGoalModal.componentInstance.settingGoalForFacebook = true;
        editGoalModal.result.then(async (result) => {
            if(this.eventService.selectedEvent.donations.individual.goal > 0) {
                await this.requestPermissionBeforeCreatingFundraiser();
            } else {
                this.ToastrService.error('Facebook requires a goal other than 0.');
            }
        }, (reason) => {});
    }

    private requestPermissionBeforeCreatingFundraiser() {

        if (this.hasPermission) {
            const facebookFundraiserModal = this.modalService.open(FacebookFundraiserDialogComponent, {
                backdrop  : 'static'
            });
            facebookFundraiserModal.componentInstance.llsAccountLogin = this.currentLLSUserLogin;
            facebookFundraiserModal.componentInstance.facebookAccountLogin = this.currentFacebookLogin;
        } else {

            //If facebook is invoked asynchronously apple treats it as an unwanted popup. Thanks apple!
            //It seems that chrome may sometimes flag the popups when there is a delay
            if (this.hybridToolsService.isMobileApp()) {
                this.requestPermissionBeforeCreatingFundraiserAsync();
            } else {
                this.requestPermissionBeforeCreatingFundraiserSync();
            }
        }
    }

    private async requestPermissionBeforeCreatingFundraiserAsync() {

        await this.facebookService.login({permissions: ['manage_fundraisers']});
        this.hasPermission = await this.facebookService.hasPermission('manage_fundraisers');
        this.showCreateFundraiserDialog();
    }

    private requestPermissionBeforeCreatingFundraiserSync() {

        this.facebookService.syncLogin({permissions: ['manage_fundraisers']}, () => {
            this.facebookService.syncHasPermission('manage_fundraisers', (result) => {
                this.hasPermission = result;
                this.showCreateFundraiserDialog();
            })
        });
    }

    private async checkPermission() {
        this.checkingPermission = true;
        this.hasPermission = await this.facebookService.hasPermission('manage_fundraisers');
        this.checkingPermission = false;
    }

    private showCreateFundraiserDialog() {
        if (this.hasPermission) {
            const facebookFundraiserModal = this.modalService.open(FacebookFundraiserDialogComponent, {
                backdrop  : 'static'
            });
            facebookFundraiserModal.componentInstance.llsAccountLogin = this.currentLLSUserLogin;
            facebookFundraiserModal.componentInstance.facebookAccountLogin = this.currentFacebookLogin;
        } else {
            //Fires changeDetectorRef.detectChanges() when activated. Helps show toast from asynchronous events outside of Angular's change detection
            this.ToastrService.error("manage_fundraisers permission is required to create the Facebook Fundraisers.", null, {onActivateTick: true});
        }
    }

    private async getCurrentFacebookLogin() {
        const profile: any = await this.facebookService.getProfile();
        this.currentFacebookLogin = profile.email;
    }

    private getCurrentLLSLogin() {
        this.currentLLSUserLogin = this.authService.currentUser().username;
    }

}
